import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../../../utilities/props.js";
import s from "./HiddenInput.module.css";
const HiddenInput = (props) => {
    const { name, value, type, onChange, onFocus, onBlur, checked, defaultChecked, disabled, className, attributes, } = props;
    const rootClassNames = classNames(s.root, className);
    return (_jsx("input", { ...attributes, className: rootClassNames, type: type, name: name, value: value, checked: checked, defaultChecked: defaultChecked, disabled: disabled, onChange: onChange, onFocus: onFocus || attributes?.onFocus, onBlur: onBlur || attributes?.onBlur }));
};
HiddenInput.displayName = "HiddenInput";
export default HiddenInput;
